<template>
    <div class="container">

        <div class="row">
            <div class="col-md-12 mt-2 mb-3">
                <h1>Evalvacija dogodkov</h1>
            </div>
        </div>



        <div class="row">
            <div class="col-md-12">

                <b-form-group
                        label="Izberi obdobje"
                        label-for="month"
                >

                    <div class="row">
                        <div class="col-md-3">
                            <v-select
                                    v-model="month"
                                    placeholder="mesec"
                                    id="month"
                                    name="month"
                                    label="name"
                                    :reduce="item => item.id"
                                    :options="[
                                {id: 1, name: 'januar'},
                                {id: 2, name: 'februar'},
                                {id: 3, name: 'marec'},
                                {id: 4, name: 'april'},
                                {id: 5, name: 'maj'},
                                {id: 6, name: 'junij'},
                                {id: 7, name: 'julij'},
                                {id: 8, name: 'avgust'},
                                {id: 9, name: 'september'},
                                {id: 10, name: 'oktober'},
                                {id: 11, name: 'november'},
                                {id: 12, name: 'december'}
                            ]"
                                    @input="$store.dispatch('setCurrentlySelectedMonth', month ? (month - 1).toString() : null); retrieveEventEvaluations()">
                                >

                                <span slot="no-options">Ni zadetkov.</span>

                            </v-select>
                        </div>
                        <div class="col-md-3">
                            <v-select
                                    v-model="year"
                                    placeholder="leto"
                                    id="year"
                                    name="month"
                                    label="name"
                                    :reduce="item => item.id"
                                    :options="[
                                {id: 2018, name: '2018'},
                                {id: 2019, name: '2019'},
                                {id: 2020, name: '2020'},
                                {id: 2021, name: '2021'},
                                {id: 2022, name: '2022'},
                                {id: 2023, name: '2023'},
                                {id: 2024, name: '2024'},
                                {id: 2025, name: '2025'},
                                {id: 2026, name: '2026'}
                            ]"
                                    @input="$store.dispatch('setCurrentlySelectedYear', year); retrieveEventEvaluations()"
                            >

                                <span slot="no-options">Ni zadetkov.</span>

                            </v-select>
                        </div>
                        <div class="col-md-3">



                        </div>
                    </div>
                </b-form-group>

<!--                                {{events}}-->

                <table class="table">
                    <thead>
                    <tr>
                        <th>#</th>
                        <th>datum dogodka</th>
                        <th>naziv dogodka</th>
                        <th>glasovanje omogočeno</th>
                        <th>št. glasov</th>
                        <th>povprečna ocena</th>
                        <th>akcije</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-if="events.length > 0"
                        v-for="(item, index) in events"
                        :key="index">
                        <td>{{index+1}}</td>
                        <td>{{moment.unix(item.date.seconds).format('DD. MM. YYYY')}}</td>
                        <td>{{item.name}}</td>
                        <td>
                          <span v-if="item.votingEnabled"><i class="fa fa-check"></i> DA</span>
                          <span v-if="!item.votingEnabled"><i class="fa fa-times"></i> NE</span>
                        </td>
                        <td>{{item.votes.length}}</td>
                        <td>
                          <span v-if="item.votes.length > 0">{{getAverageVal(item.votes)}}</span>
                          <span v-if="item.votes.length === 0">0</span>
                        </td>
                        <td>
                            <router-link :to="{ name: 'EventEvaluationVote', params: {id: item.id }}"
                                         class="btn btn-info btn-sm text-white"><i class="fa fa-thumbs-up"></i> Na glasovanje
                            </router-link>
                          <router-link :to="{ name: 'EditEventEvaluation', params: {id: item.id }}"
                                       class="btn btn-primary btn-sm text-white"><i class="fa fa-edit"></i> Uredi
                          </router-link>
                        </td>
                    </tr>
                    <tr v-if="events.length == 0">
                        <td colspan="5" class="text-center">
                            <em class="text-muted"><i class="fa fa-exclamation-triangle"></i> Ni vnešenih dogodkov</em>
                        </td>
                    </tr>
                    </tbody>
                </table>

            </div>
        </div>

        <div class="row">
            <div class="col-md-12 mt-3 mb-5">

                <router-link :to="{ name: 'EditEventEvaluation' }" class="btn btn-success">
                    <i class="fa fa-plus"></i> Dodaj evalvacijo dogodka
                </router-link>

            </div>
        </div>


    </div>
</template>

<script>
  import firebase from 'firebase'
  import {db} from '../main'
  import {VueGoodTable} from 'vue-good-table'
  import 'vue-good-table/dist/vue-good-table.css'
  import vSelect from 'vue-select'
  import 'vue-select/dist/vue-select.css'

  export default {
    name: 'Events',
    components: {
      VueGoodTable,
      vSelect,
    },
    data () {
      return {
        month: parseInt(this.$store.getters.getCurrentlySelectedMonth) + 1,
        year: parseInt(this.$store.getters.getCurrentlySelectedYear),
        events: [],
        // allEvents: this.$store.getters.getEvents,
        projects: this.$store.getters.getProjects,
        users: this.$store.getters.getUsers,
        columns: [
          {
            label: 'Slika',
            field: 'photo',
            type: 'text',
            sortable: false,
            width: '70px'
          },
          {
            label: 'Ime',
            field: 'first_name',
            type: 'text',
            sortable: true,
          },
          {
            label: 'Priimek',
            field: 'last_name',
            type: 'text',
            sortable: true,
          },
          {
            label: 'Email',
            field: 'email',
            type: 'text',
            sortable: false,
            width: '300px'
          },
          {
            label: 'Aktivnost',
            field: 'active',
            type: 'text',
            sortable: true,
          },
          {
            label: 'Akcije',
            field: 'id',
            type: 'text',
            sortable: false,
            width: '200px'
          },
        ]
      }
    },
    mounted () {
      const _this = this

      // if (_this.$store.getters.getEvents.length === 0) {
      //   _this.$store.dispatch('retrieveEvents').then(() => {
      //     _this.allEvents = _this.$store.getters.getEvents
      //     _this.retrieveEvents();
      //   })
      // } else {
      //   _this.retrieveEvents();
      // }
      _this.retrieveEventEvaluations();

      if (_this.$store.getters.getProjects.length === 0) {
        _this.$store.dispatch('retrieveProjects').then(() => {
          _this.projects = _this.$store.getters.getProjects
        })
      }

      if (_this.$store.getters.getUsers.length === 0) {
        _this.$store.dispatch('retrieveUsers').then(() => {
          _this.users = _this.$store.getters.getUsers
        })
      }

    },
    methods: {
      dateFormat(value){
        return this.moment.unix(value.seconds).format('DD. MM. YYYY');
      },

      dateFormatHours(value){
        if(!value || value === 'undefined') {
          return '/'
        } else {
          return this.moment.unix(value.seconds).format('HH:mm');
        }
      },

      projectFormat(value){
        return this.getReadableProject(value);
      },

      staffNumFormat(value){
        if(!value || value === 'undefined') {
          return 0;
        } else {
          return value.length
        }
      },

      staffFormat(value){
        let _this = this;
        let staff = '';

        if(!value || value === 'undefined') {
          return '';
        }

        _.each(value, function (val) {
            staff += _this.getReadableUser(val) + ', ';
        })

        staff = staff.substring(0, staff.length - 2);
        return staff;
      },

      retrieveEventEvaluations() {
        const _this = this

        let startDate = _this.moment().set({
          date: 1,
          month: _this.month ? _this.$store.getters.getCurrentlySelectedMonth : 0,
          year: _this.$store.getters.getCurrentlySelectedYear
        }).startOf('month');

        console.log("_this.$store.getters.getCurrentlySelectedMonth",_this.$store.getters.getCurrentlySelectedMonth);
        let endDate = _this.month ? _this.moment(startDate).endOf('month') : _this.moment(startDate).endOf('year');
        console.log("endDate", endDate);

        let events = db.collection('eventEvaluation')

        events
          .where('date', '>=', _this.moment(startDate).toDate())
          .where('date', '<=', _this.moment(endDate).toDate())
          .get()
          .then(querySnapshot => {
            _this.events = querySnapshot.docs.map(doc => doc.data());

            _this.isLoading = false
          })
          .catch(function (error) {
            // The document probably doesn't exist.
            console.log('Error getting documents: ', error)
            _this.isLoading = false
          })

      },
      deleteEventConfirmation (data) {
        const _this = this

        this.$swal({
          title: 'Opozorilo',
          text: 'Ali ste prepričani, da želite izbrisati dogodek ' + data.first_name + ' ' + data.last_name + '? Po potrditvi izbire ne bo več mogoče preklicati.',
          dangerMode: true,
          buttons: {
            cancel: {
              text: 'Prekliči',
              value: null,
              visible: true,
              className: '',
              closeModal: true,
            },
            confirm: {
              text: 'Izbriši',
              value: true,
              visible: true,
              className: '',
              closeModal: true
            }
          },
        })
          .then((value) => {

            switch (value) {

              case true:

                _this.deleteUser(data.id)

              case null:

                return

                break

              default:

            }
          })
      },
      deleteEvent (id) {
        db.collection('events').doc(id).delete()
          .then(function () {
            _this.$router.push('/dogodki')
          })
          .catch(function (error) {
            // The document probably doesn't exist.
            console.error('Error deleting event: ', error)
          })
      },
      getReadableProject (projects) {
        const _this = this
        let readableProjects = '';

        console.log(projects);

        _.each(projects, function (val, index) {
          let projectObj = _.filter(_this.projects, {'id': val})[0]
          if (projectObj) {
            readableProjects += projectObj.name + (index+1 < projects.length ? ', ' : '')
          } else {
            readableProjects += 'n/a' + (index+1 < projects.length ? ', ' : '')
          }
        });

        return readableProjects

      },
      getReadableUser (userId) {
        const _this = this

        let userObj = _.filter(_this.users, {'id': userId})[0]
        if (userObj) {
          return userObj.first_name + ' ' + userObj.last_name
        } else {
          return 'n/a'
        }
      },
      getReadableStatus (currentFormStep) {
        const _this = this
        console.log(currentFormStep);
        let status = '';

        switch (currentFormStep) {
          case 1:
             status = '1 - načrtovan'
            break
          case 2:
            status = '2 - potrjen'
            break
          case 3:
            status = '3, 4 - poročanje'
            break
        }

        return status

      },
      getAverageVal(votes) {
        return _.meanBy(votes, (p) => p.score).toFixed(2);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/EventEvaluation.vue